var tripPrivacyDetails = {
    public: {
        label: "Open to All",
        description: "Anyone can join this trip. No invitation or approval needed.",
        color: "#1b5e20", // deep green
        backgroundColor: "#e8f5e9", // light green
        borderColor: "#a5d6a7",
        //icon: <PublicIcon fontSize="small" />,
        icon: true,
    },
    "invite-only": {
        label: "Invitation Only",
        description: "This trip is limited to selected participants. You'll need an invite to join.",
        color: "#6a1b9a", // purple tone
        backgroundColor: "#f3e5f5",
        borderColor: "#ce93d8",
        //icon: <LockIcon fontSize="small" />,
        icon: true,
    },
    approval: {
        label: "Approval Required",
        description: "Request to join this trip. The organizer will review and approve participation.",
        color: "#e65100", // orange tone
        backgroundColor: "#fff3e0",
        borderColor: "#ffcc80",
        //icon: <ApprovalIcon fontSize="small" />,
        icon: true,
    },
};
export default tripPrivacyDetails;
